<template>
  <v-row>
    <v-col
      cols="12"
    >
      <v-alert
        v-show="copyAlert"
        type="info"
        text
      >
        {{ msgtokencopiado }}
      </v-alert>
      <v-alert
        v-show="alertStatus"
        type="success"
        text
      >
        {{ msgAlertStatus }}
      </v-alert>
      <v-alert
        v-show="alertAppTypeStatus"
        type="success"
        text
      >
        {{ msgUpdateTypeAppStatus }}
      </v-alert>
      <base-card>
        <v-card-text>
          <v-card-title>
            Listados Clientes FE
            <v-spacer />
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Buscar"
              single-line
              hide-details
            />
            <v-spacer />
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="details"
            :search="search"
            class="elevation-1"
          >
            <template v-slot:[`item.status`]="{ item }">
              <v-icon
                v-if="item.status === 'T'"
                color="yellow darken-2"
                right
                class="mr-2"
              >
                mdi-alpha-t-circle
              </v-icon>
              <v-icon
                v-else-if="item.status === 'P'"
                color="success darken-2"
                right
                class="mr-2"
              >
                mdi-alpha-p-circle
              </v-icon>

              <v-icon
                v-else
                color="info darken-2"
                right
                class="mr-2"
              >
                mdi-alpha-d-circle
              </v-icon>
            </template>
            <template v-slot:[`item.active`]="{ item }">
              <v-icon
                v-if="item.active === 1"
                color="success darken-2"
                right
                class="mr-2"
              >
                mdi-account-check
              </v-icon>
              <v-icon
                v-else
                color="warning darken-2"
                right
                class="mr-2"
              >
                mdi-account-cancel
              </v-icon>
            </template>
            <template v-slot:[`item.token_enterprise`]="{ item }">
              <v-icon
                v-clipboard:copy="item.token_enterprise"
                v-clipboard:success="onCopy"
                style="cursor:pointer;"
                color="info darken-3"
                class="mr-2"
              >
                mdi-content-copy
              </v-icon>
            </template>
            <template v-slot:[`item.token_password`]="{ item }">
              <v-icon
                v-clipboard:copy="item.token_password"
                v-clipboard:success="onCopy"
                style="cursor:pointer;"
                color="info darken-3"
                class="mr-2"
              >
                mdi-content-copy
              </v-icon>
            </template>
            <template v-slot:[`item.app_types`]="{ item }">
              <v-menu
                v-model="menuVisible[item.id]"
                :close-on-content-click="false"
                transition="slide-x-reverse-transition"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    style="cursor:pointer;"
                    color="blue darken-1"
                    class="mr-2"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-apps
                  </v-icon>
                </template>
                <v-card>
                  <v-card-title>Activar/Desactivar Apps</v-card-title>
                  <v-divider></v-divider>
                  <v-list>
                    <template v-for="app in compareArrays(appTypes, details, item.id)">
                      <v-list-item>
                        <v-checkbox
                          v-model="app.active"
                          :label="app.name"
                          color = "rgb(204 33 40)"
                          @change="handleCheckboxChange(app, item.id)"
                        />
                      </v-list-item>
                    </template>
                  </v-list>
                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-btn
                      style="background-color:rgb(204 33 40);color:white !important"
                      @click="menuVisible[item.id] = false"
                    >
                      Cerrar
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-menu>
            </template>

            <template v-slot:[`item.Acciones`]="{ item }">
              <div style="display: flex; align-items: center; justify-content: center;">
                <v-icon
                  style="cursor:pointer;"
                  color="blue darken-2"
                  class="mr-2"
                  @click="openEditModal(item)"
                >
                  mdi-pencil
                </v-icon>
                <v-icon
                  v-if="item.active == 1"
                  style="cursor:pointer;"
                  color="red darken-3"
                  @click="activeInactiveClients(item)"
                >
                  mdi-account-cancel
                </v-icon>
                <v-icon
                  v-else
                  style="cursor:pointer;"
                  color="success darken-3"
                  @click="activeInactiveClients(item)"
                >
                  mdi-account-check
                </v-icon>
              </div>
            </template>
            <template v-slot:[`item.url_image`]="{ item }">
              <div id="preview">
                <img style="width:60%":src="item.url_image" />
              </div>
            </template>


          </v-data-table>
        </v-card-text>
      </base-card>
      <edit-client-modal
        :show="editClientShow"
        :client="selectedClient"
        @close="closeEditModal"
        @updated="onClientUpdated"
      />
    </v-col>
  </v-row>
</template>

<script>
  import EditClientModal from './EditClientModal.vue'

  export default {
    name: 'ShowClients',
    components: {
      EditClientModal,
    },
    data () {
      return {
        search: '',
        copyAlert: false,
        msgtokencopiado: 'Token Copiado',
        msgAlertStatus: 'Estado de cliente modificado',
        msgUpdateTypeAppStatus: 'Estatus de aplicaciones actualizado',
        alertStatus: false,
        alertAppTypeStatus: false,
        menuVisible: {},
        appsSelected: '',
        appTypeUpdated: {},
        editClientShow: false,
        selectedClient: {},
        headers: [
          { text: 'Razón Social', value: 'legal_name' },
          { text: 'RUC', value: 'ruc' },
          { text: 'Nombre Establecimiento', value: 'name' },
          { text: 'Ambiente', value: 'status' },
          { text: 'Estado', value: 'active' },
          { text: 'Token Enterprise', align: 'center', sortable: false, value: 'token_enterprise' },
          { text: 'Token Password', align: 'center', sortable: false, value: 'token_password' },
          { text: 'Apps', value: 'app_types', align: 'center' },
          { text: 'Url logo', value: 'url_image', align: 'center' },
          { text: 'Correo Notificación', value: 'email' },
          { text: 'Dirección Matriz', value: 'main_address' },
          { text: 'RUC Proveedor FE', value: 'ruc_provider_fe' },
          { text: 'Fecha Creación   ', value: 'created_at' },
          { text: 'Fecha Actualización', value: 'updated_at' },
          { text: 'Acciones', value: 'Acciones', align: 'center', sortable: false },
        ],
      }
    },
    computed: {
      details () {
        return this.$store.state.clients.listClients.Mensaje
      },
      appTypes () {
        return this.$store.state.clients.appTypes
      },
      updateResponseClient () {
        return this.$store.state.clients.updateStatusResponse
      },
      updateAppTypeResponseClient () {
        return this.$store.state.clients.updateAppTypesResponse
      },
    },
    watch: {
      updateResponseClient () {
        if (this.updateResponseClient > 0) {
          this.generateAlertStatus()
          this.$store.dispatch('clients/setUpdateResponseClient', 0)
        }
      },
      updateAppTypeResponseClient () {
        if (this.updateAppTypeResponseClient > 0) {
          this.generateAppTypeAlertStatus()
          this.$store.dispatch('clients/setUpdateAppTypesResponse', 0)
        }
      },
    },
    created () {
      this.getListClients()
    },
    methods: {
      generateAlertStatus () {
        this.alertStatus = true
        this.$store.dispatch('clients/getListClients')
        setTimeout(() => {
          this.alertStatus = false
        }, 3000)
      },
      generateAppTypeAlertStatus () {
        this.alertAppTypeStatus = true
        this.$store.dispatch('clients/getListClients')
        setTimeout(() => {
          this.alertAppTypeStatus = false
        }, 3000)
      },
      onCopy (e) {
        this.generateAlertCopy()
      },
      generateAlertCopy () {
        this.copyAlert = true
        setTimeout(() => {
          this.copyAlert = false
        }, 2000)
      },
      async getListClients () {
        await this.$store.dispatch('clients/getListClients')
      },
      async activeInactiveClients (item) {
        await this.$store.dispatch('clients/activeInactiveClient', item)
      },
      async updateAppTypesClient (app) {
        await this.$store.dispatch('clients/updateAppTypes', app)
      },
      handleCheckboxChange(item, IdCompania) {
        this.appTypeUpdated.IdCompania = IdCompania
        this.appTypeUpdated.IdTipoApp = item.id || item.app_type_id
        this.appTypeUpdated.Activo = item.active
        this.updateAppTypesClient(this.appTypeUpdated)
      },
      compareArrays(array1, companies, specificIdCompania) {
        const specificCompany = companies.find(company => company.id === specificIdCompania);
        const array2 = (specificCompany.app_types || [])
          .filter(app => app.active !== null)
          .map(app => ({
            ...app,
            name: app.app_type ? app.app_type.name : app.name,
          }))
        const existElements = new Set(array2.map(item => item.app_type_id));
        return [
          ...array2,
          ...array1
            .filter(item => !existElements.has(item.id))
            .map(item => ({...item, active: 0}))
        ].sort((a, b) => (a.id || a.app_type_id) - (b.id || b.app_type_id));
      },
      openEditModal (client) {
        this.selectedClient = client
        this.editClientShow = true
      },
      closeEditModal () {
        this.editClientShow = false
        this.selectedClient = {}
      },
      onClientUpdated () {
        this.getListClients()
      },
    },
  }
</script>

<style scoped>

</style>
